import axios from "../axiosInstance";
import type {
  MembershipSku,
  UpdateMembershipSkuFormData,
} from "@/modules/hub/features/MembershipSkuManagement/schemas/membershipSkuSchema";

/**
 * Update an existing membership SKU
 */
export const updateMembershipSku = async (
  uuid: string,
  data: UpdateMembershipSkuFormData,
): Promise<MembershipSku> => {
  const response = await axios.put<MembershipSku>(
    `/api/private/membership-skus/${uuid}`,
    data,
  );
  return response.data;
};
